import {applyMiddleware, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {createStateSyncMiddleware, initMessageListener} from "redux-state-sync";

import Reducer from "./Reducer.js";
import State from "./State.js";

/**
 * `redux-persist`
 */
const rpc = {
	storage,
	key: "app",
	whitelist: [
		"api",
		"args",
		"auth",
		"checkoutBasket",
		"checkoutBasketDiscounts",
		"checkoutBasketId",
		"checkoutBasketExpiry",
		"checkoutBasketCountry",
		"checkoutBasketUpsells",
		"checkoutRedirectUri",
		"cookieConsentToOptional",
		"featuresForced"
	]
};

/**
 * `redux-state-sync`
 */
const rss = {
	blacklist: ["loading", "seatReservationDialog", "persist/PERSIST", "persist/REHYDRATE"],
	broadcastChannelOption: {webWorkerSupport: false}
};

/**
 * Create our store
 */
const store = createStore(
	persistReducer(rpc, Reducer),
	State,
	composeWithDevTools(applyMiddleware(createStateSyncMiddleware(rss)))
);

/**
 * Create our store persistor
 */
const persistor = persistStore(store);

/**
 * Initialise synchronisation listener
 */
initMessageListener(store);

/**
 * Expose the store on `window` to aid development/debugging
 */
window.__hops_redux_store = store;

export default store;
export {store as Store, persistor as StorePersistor};
